import ImagesBuyGuideBuyerGuide2Svg from '@/public/images/buy-guide/buyer-guide2.svg';
import ImagesBuyGuideBuyerGuideSvg from '@/public/images/buy-guide/buyer-guide.svg';
import ImagesBuyGuideFrame427319761Svg from '@/public/images/buy-guide/Frame 427319761.svg';
import ImagesBuyGuideMainImageMobileWebp from '@/public/images/buy-guide/mainImageMobile.webp';
import ImagesBuyGuideOption1TabSvg from '@/public/images/buy-guide/option1Tab.svg';
import ImagesBuyGuideOption1botSvg from '@/public/images/buy-guide/option1bot.svg';
import ImagesBuyGuideOption2TabSvg from '@/public/images/buy-guide/option2Tab.svg';
import ImagesBuyGuideOption2botSvg from '@/public/images/buy-guide/option2bot.svg';
import ImagesBuyGuideSection5Svg from '@/public/images/buy-guide/section5.svg';
import ImagesBuyGuideSection9Svg from '@/public/images/buy-guide/section9.svg';
import ImagesBuyGuideSignUpSvg from '@/public/images/buy-guide/signUp.svg';
import ImagesBuyGuideTagSvg from '@/public/images/buy-guide/tag.svg';

export {
  ImagesBuyGuideBuyerGuide2Svg,
  ImagesBuyGuideBuyerGuideSvg,
  ImagesBuyGuideFrame427319761Svg,
  ImagesBuyGuideMainImageMobileWebp,
  ImagesBuyGuideOption1TabSvg,
  ImagesBuyGuideOption1botSvg,
  ImagesBuyGuideOption2TabSvg,
  ImagesBuyGuideOption2botSvg,
  ImagesBuyGuideSection5Svg,
  ImagesBuyGuideSection9Svg,
  ImagesBuyGuideSignUpSvg,
  ImagesBuyGuideTagSvg,
};
